export enum AddressType {
    Contact = 1,
    Public = 2,
    Shipping = 6
}